import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { userLoginReducer, userSignupReducer } from './reducers/userReducers';
import { accountsListReducer } from './reducers/accountReducers';

const reducer = combineReducers({
  userLogin: userLoginReducer,
  userSignup: userSignupReducer,
  accountsList: accountsListReducer,
});

const storageUserData = localStorage.getItem('userData')
  ? // @ts-ignore
    JSON.parse(localStorage.getItem('userData'))
  : null;

const initialState = {
  userLogin: { userData: storageUserData },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
